import { render, staticRenderFns } from "./Sugerencias.vue?vue&type=template&id=38ecd0a8&scoped=true"
import script from "./Sugerencias.vue?vue&type=script&lang=js"
export * from "./Sugerencias.vue?vue&type=script&lang=js"
import style0 from "./Sugerencias.vue?vue&type=style&index=0&id=38ecd0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ecd0a8",
  null
  
)

export default component.exports